import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";

import {
  CFontIcon,
  Flex,
  Box,
  Text,
  H3,
  CLabel,
  CCard
} from "@appcues/component-library";
import { navigate } from "actions/routing";

import ThemeOptions from "components/Themes/ThemeEdit/ThemeOptions";
import ThemeImage from "components/Themes/ThemeImage";

import {
  selectFlows,
  selectStepGroups,
  selectAreFlowsSynced
} from "reducers/account/flows";
import { getFlowsUsingTheme } from "helpers/themes";
import { modalPreviewContent } from "constants/account/themes";

const ThemeCard = ({ theme, themeId }) => {
  const accountSteps = useSelector(state => selectStepGroups(state));
  const accountFlows = useSelector(state => selectFlows(state));
  const accountFlowsSynced = useSelector(state => selectAreFlowsSynced(state));
  const flows = getFlowsUsingTheme({
    flows: accountFlows,
    steps: accountSteps,
    themeId
  });

  const dispatch = useDispatch();

  const navigateToTheme = useCallback(() => {
    dispatch(navigate(`themes/${themeId}/edit`));
  }, [dispatch, themeId]);

  const isLoaded = accountFlowsSynced;
  return (
    <CCard onClick={navigateToTheme} padding={16}>
      <Flex alignItems="center" paddingBottom={8}>
        <H3
          type="secondary"
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
          title={theme.name}
        >
          {theme.name}
        </H3>
        <Box marginLeft="auto">
          <ThemeOptions theme={theme} themeId={themeId} border={0} />
        </Box>
      </Flex>
      <ThemeImage content={modalPreviewContent} theme={theme} />
      <Box is="footer">
        <UsageIcon>
          <CFontIcon className="fas fa-map" fontSize="10px" />
        </UsageIcon>
        {isLoaded && (
          <Text type="tertiary">Used in {flows.length || 0} flows</Text>
        )}
        {theme.isDefault && (
          <CLabel type="draft" float="right">
            Default
          </CLabel>
        )}
      </Box>
    </CCard>
  );
};

ThemeCard.propTypes = {
  theme: PropTypes.object.isRequired,
  themeId: PropTypes.string.isRequired
};

ThemeCard.defaultProps = {
  theme: {}
};

const UsageIcon = styled.span`
  background-color: ${props => props.theme["$gray-1"]};
  border-radius: 12px;
  display: inline-block;
  height: 24px;
  margin-right: 8px;
  text-align: center;
  width: 24px;
`;

export default ThemeCard;
